<template>
  <div>
    <v-data-table
      class="astra-table"
      dense
      height="74vh"
      fixed-header
      :headers="controller.headers"
      :options.sync="controller.options"
      :server-items-length="controller.serviceOrderPagination.total"
      :items="controller.serviceOrderPagination.items"
      :loading="controller.loading"
      :footer-props="{
        'items-per-page-options': [40, 80],
      }"
    > 
      <template v-slot:[`item.active`]="{ item }">
        <v-checkbox
          color="primary"
          class="mt-0 pt-0"
          v-model="item.active"
          hide-details
          readonly
          dense
        >
        </v-checkbox>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <div>
          <v-btn 
          icon 
          @click="controller.change(item)" 
          class="px-2"
          v-if="hadPermission(18,2)">
            <v-icon color="editBtn" small>mdi-pencil</v-icon>
          </v-btn>
          <v-btn 
          icon 
          @click="controller.delete(item)" 
          class="px-2"
          v-if="hadPermission(18,3)">
            <v-icon color="deleteBtn" small>mdi-delete</v-icon>
          </v-btn>
        </div>
      </template>
      <template v-slot:[`item.createdDate`]="{ item }">
        {{
          item.createdDate
            ? dayjs(item.createdDate).format("DD/MM/YYYY HH:mm")
            : "---"
        }}
      </template>
      <template v-slot:[`item.startDate`]="{ item }">
        {{
          item.startDate ? dayjs(item.startDate).format("DD/MM/YYYY") : "---"
        }}
      </template>
      <template v-slot:[`item.endDate`]="{ item }">
        {{ item.endDate ? dayjs(item.endDate).format("DD/MM/YYYY") : "---" }}
      </template>
      
      <template v-slot:top>
        <v-row class="pa-3" no-gutters>
          <v-col
            :class="
              $vuetify.breakpoint.smAndDown
                ? 'py-3 d-flex align-center justify-center'
                : 'd-flex align-center'
            "
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <span class="table-title">Agendamento de OS</span>
          </v-col>
          <v-col
           :class="
              $vuetify.breakpoint.smAndDown
                ? 'd-flex flex-column align-center justify-center'
                : 'd-flex align-center justify-end'
            "
            cols="12"
            sm="12"
            md="6"
            lg="6"
            xl="6"
          >
            <div style="width: 200px">
              <v-select
                outlined
                dense
                color="primary"
                v-model="controller.statusSelected"
                :items="controller.statusList"
                hide-details
                class="pa-2 search-tf"
                item-text="text"
                item-value="value"
                @change="controller.changeStatus()"
              ></v-select>
            </div>
            <div style="width: 300px">
              <v-text-field
                class="px-2 search-tf"
                outlined
                color="primary"
                hide-details
                dense
                placeholder="Pesquisar..."
                v-model="controller.search"
              ></v-text-field>
            </div>
            <v-dialog
              max-width="600"
              scrollable
              persistent
              v-model="controller.dialog"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="action-btn d-flex justify-center"
                  height="40"
                  color="primary"
                  v-bind="attrs"
                  v-on="on"
                  tile
                  @click.stop="controller.open()"
                  v-if="hadPermission(18,1)"
                >
                  <v-icon left>mdi-plus</v-icon>
                  Adicionar
                </v-btn>
              </template>
              <v-card class="crud-card">
                <v-card-title>
                  <v-spacer></v-spacer>
                  <span class="table-title">Agendamento de OS</span>
                  <v-spacer></v-spacer>
                </v-card-title>
                <v-card-text class="pt-3 pb-1">
                  <v-form ref="crud" lazy-validation>
                    <v-row no-gutters>
                      <v-col cols="12" class="d-flex justify-center">
                        <v-switch
                          v-model="controller.form.active"
                          inset
                          label="Ativo"
                        ></v-switch>
                      </v-col>
                      <v-col>
                        <div class="form-input-group">
                          <v-autocomplete
                            class="search-tf"
                            single-line
                            id="taskType"
                            :rules="[(v) => !!v || 'Campo obrigatório']"
                            background-color="transparent"
                            outlined
                            required
                            dense
                            placeholder="Tipo da Tarefa"
                            v-model="controller.form.taskTypeID"
                            :search-input.sync="controller.searchTaskType"
                            :items="controller.taskTypePagination.items"
                            item-text="name"
                            item-value="id"
                          />
                          <label for="taskType">Tipo da Tarefa</label>
                        </div>
                        <div class="form-input-group">
                          <v-autocomplete
                            class="search-tf"
                            single-line
                            id="client"
                            :rules="[(v) => !!v || 'Campo obrigatório']"
                            background-color="transparent"
                            outlined
                            required
                            dense
                            placeholder="Cliente"
                            v-model="controller.form.clientID"
                            :search-input.sync="controller.searchClient"
                            :items="controller.clientPagination.items"
                            item-text="name"
                            item-value="id"
                          />
                          <label for="client">Cliente</label>
                        </div>
                        <div class="form-input-group">
                          <v-autocomplete
                            class="search-tf"
                            single-line
                            id="vehicle"
                            :rules="[(v) => !!v || 'Campo obrigatório']"
                            background-color="transparent"
                            outlined
                            required
                            dense
                            placeholder="Veículo"
                            v-model="controller.form.vehicleID"
                            :search-input.sync="controller.searchVehicle"
                            :items="controller.vehiclePagination.items"
                            item-text="plate"
                            item-value="id"
                          />
                          <label for="vehicle">Veículo</label>
                        </div>
                        <div v-if="hadPermission(0,0)" class="form-input-group">
                          <v-autocomplete
                            class="search-tf"
                            single-line
                            id="technician"
                            :rules="[(v) => !!v || 'Campo obrigatório']"
                            background-color="transparent"
                            outlined
                            required
                            dense
                            placeholder="Técnico"
                            v-model="controller.form.technicianID"
                            :search-input.sync="controller.searchTechnician"
                            :items="controller.technicianPagination.items"
                            item-text="name"
                            item-value="id"
                          />
                          <label for="technician">Técnico</label>
                        </div>
                        <div class="form-input-group">
                          <v-autocomplete
                            class="search-tf"
                            single-line
                            id="status"
                            :rules="[(v) => !!v || 'Campo obrigatório']"
                            background-color="transparent"
                            outlined
                            required
                            dense
                            placeholder="Status"
                            v-model="controller.form.serviceOrderStatusID"
                            :search-input.sync="controller.searchStatus"
                            :items="controller.statusPagination.items"
                            item-text="name"
                            item-value="id"
                          />
                          <label for="status">Status</label>
                        </div>
                        <div class="form-input-group">
                          <v-text-field
                            class="search-tf"
                            single-line
                            id="address"
                            background-color="transparent"
                            required
                            outlined
                            dense
                            counter
                            maxlength="200"
                            placeholder="Endereço"
                            v-model="controller.form.address" 
                            :rules="[(v) => !!v || 'Campo obrigatório']"
                          />
                          <label for="address">Endereço</label>
                        </div>
                        <v-row>
                          <v-col cols="12" md="6">
                            <div class="form-input-group">
                              <date-picker
                                class="search-tf"
                                single-line
                                id="startDate"
                                background-color="transparent"
                                outlined
                                required
                                dense
                                label="Data de Início"
                                v-model="controller.form.startDate"
                              ></date-picker>
                              <label for="startDate">Data de Início</label>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                            <div class="form-input-group">
                              <date-picker
                                class="search-tf"
                                single-line
                                id="endDate"
                                background-color="transparent"
                                outlined
                                required
                                dense
                                label="Data Final"
                                v-model="controller.form.endDate"
                              ></date-picker>
                              <label for="endDate">Data Final</label>
                            </div>
                          </v-col>
                        </v-row>
                        <div class="form-input-group">
                          <v-textarea
                            class="search-tf"
                            single-line
                            id="description"
                            background-color="transparent"
                            outlined
                            dense
                            counter
                            maxlength="250"
                            placeholder="Descrição"
                            v-model="controller.form.description"
                          />
                          <label for="Description">Descrição</label>
                        </div>
                      </v-col>
                    </v-row>
                  </v-form>
                  <v-divider></v-divider>
                </v-card-text>
                <v-card-actions class="px-6 pb-3">
                  <v-btn
                    class="action-btn d-flex justify-center"
                    height="36"
                    width="114"
                    color="primary"
                    outlined
                    @click="controller.close()"
                  >
                    <v-icon left>mdi-close</v-icon>
                    Cancelar
                  </v-btn>
                  <v-spacer></v-spacer>
                  <v-btn
                    class="action-btn d-flex justify-center"
                    height="36"
                    width="114"
                    color="primary"
                    @click="controller.create()"
                    :loading="controller.loading"
                  >
                    <v-icon left>mdi-content-save</v-icon>
                    Salvar
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>
          </v-col>
        </v-row>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import dayjs from "dayjs";

import { serviceOrderController } from "@/di/di";
import { hadPermission } from "@/core/domain/model/permission";

export default {
  name: "serviceOrder-page",
  data: (context) => ({
    controller: serviceOrderController(context),
  }),
  watch: {
    "controller.options"() {
      this.controller.watchOptions();
    },
    "controller.search"() {
      this.controller.watchSearch();
    },
    "controller.clientOptions"() {
      this.controller.watchClientOptions();
    },
    "controller.searchClient": _.debounce(function () {
      this.controller.watchClientSearch();
    }, 500),
    "controller.vehicleOptions"() {
      this.controller.watchVehicleOptions();
    },
    "controller.searchVehicle": _.debounce(function () {
      this.controller.watchVehicleSearch();
    }, 500),
    "controller.technicianOptions"() {
      this.controller.watchTechnicianOptions();
    },
    "controller.searchTechnician": _.debounce(function () {
      this.controller.watchTechnicianSearch();
    }, 500),
    "controller.taskTypeOptions"() {
      this.controller.watchTaskTypeOptions();
    },
    "controller.searchTaskType": _.debounce(function () {
      this.controller.watchTaskTypeSearch();
    }, 500),
    "controller.statusOptions"() {
      this.controller.watchStatusOptions();
    },
    "controller.searchStatus": _.debounce(function () {
      this.controller.watchStatusSearch();
    }, 500),
  },
};
</script>

<style scoped lang="scss">
.astra-table {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

.toolbar-table {
  border-top-left-radius: 20px !important;
  border-top-right-radius: 20px !important;
}

::v-deep .v-data-table.v-data-table--fixed-header thead th {
  background-color: var(--v-secondary-base) !important;
}

.action-btn {
  text-transform: none;
  border-radius: 10px !important;
}

.search-tf {
  border-radius: 10px !important;
}

.table-title {
  font-family: "Roboto";
  font-style: normal;
  font-weight: 300;
  font-size: 20px;
  line-height: 20px;
  text-align: center;
}

.crud-card {
  border-radius: 20px;
  background-color: var(--v-secondary-base) !important;
}

::v-deep .v-dialog {
  border-radius: 20px !important;
}

label {
  order: -1;
}

.v-input:focus-within + label {
  color: var(--v-primary-base) !important;
}

.form-input-group {
  display: flex;
  flex-direction: column;
}

::v-deep tbody {
  tr:hover {
    background-color: var(--v-tertiary-base) !important;
  }
}
</style>
